__turbopack_context__.v({
  "component": "style-module-scss-module___uhIla__component",
  "cta-button": "style-module-scss-module___uhIla__cta-button",
  "disclaimer": "style-module-scss-module___uhIla__disclaimer",
});
